var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartNormal',{attrs:{"size":"12","offset":"0","title":"Tested","chart":"column","chartType":"tested","isCity":false,"withDate":true,"withFinancial":false,"tested":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }